import { combineEpics } from 'redux-observable';
import { HubUsersActionTypes, FetchHubUsers } from '../actions/HubUsersActions';
import RequestStatusTypes from '../constants/RequestStatusTypes';
import HubUsersAPI from '../api/HubUsersApi';
import requestEntity from './requestEntity';
import RequestEpicDescriptor from './RequestEpicDescriptor';
import { getFetchHubUsersRequestStatus } from '../selectors/RequestStatusSelector';
const fetchHubUsers = requestEntity(new RequestEpicDescriptor({
  apiFunction: HubUsersAPI.getHubUsers,
  initiatingActionType: HubUsersActionTypes.LOAD_HUB_USERS,
  requestStatusSelector: getFetchHubUsersRequestStatus,
  requestStatusTypeFilters: [RequestStatusTypes.UNINITIALIZED, RequestStatusTypes.FAILED],
  requestActions: FetchHubUsers
}));
export default combineEpics(fetchHubUsers);